import { generalConfigStore, setPageOrderTakingCompositeProduct } from "@store";

// Persiste un patch partiel dans `compositeProduct` du template (étape produit
// composé, ESS-3857). Lecture du store live (et non d'un snapshot de rendu) :
// setPageOrderTakingCompositeProduct remplace tout l'objet, d'où le merge sur
// l'état courant. Null-guard si la page orderTaking est absente du template.
export function persistCompositeProductPatch(
    extra: Record<string, unknown>
): void {
    const orderTakingPage = generalConfigStore.project.template.pages.ways[
        "orderTaking"
    ] as OrderTakingPageType | undefined;
    if (!orderTakingPage) {
        return;
    }
    setPageOrderTakingCompositeProduct({
        ...orderTakingPage.compositeProduct,
        ...extra,
    });
}
